import { getApi } from './api';
import { viderBrouillon, viderReprise } from './brouillon';
import { effacerSession, lireSession } from './session';

/**
 * "Se déconnecter": tells the adapter, then empties the session whatever happened,
 * so a failing service never keeps a user signed in. Going back to `/login` is up to
 * the caller. The draft is emptied too (#24): it is not kept per account, and the next one to
 * sign in on this tab must never see the text of the previous one.
 */
export async function deconnecter(): Promise<void> {
  const session = lireSession();
  try {
    if (session !== null) await getApi().logout(session);
  } finally {
    effacerSession();
    viderBrouillon();
    viderReprise();
  }
}
